module.exports = "<p>\n Model:\n</p>\n\n\n<div  #rendererContainer></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/inner-space/main-scene/main-right/main-right.component.html
// module id = ./src/app/inner-space/main-scene/main-right/main-right.component.html
// module chunks = main